import { Option } from '@sapphire/result';

import { NotificationAction, NotificationItem } from '@ps/notification-models';

import { NotificationActionApplyResult } from './notification.model';

export function withResult(
  action: NotificationAction,
  result: NotificationActionApplyResult,
): NotificationAction {
  return {
    ...action,
    state: result.state,
    resultLabel: result.resultLabel,
    appliedBy: result.appliedBy,
    appliedAt: result.appliedAt,
  };
}

// Action transitions reach the server through SQS, so a reload right after apply can still read pending.
export function withKnownActionStates(
  incoming: NotificationItem[],
  known: NotificationItem[],
): NotificationItem[] {
  const knownById = new Map(
    known.map((notification) => [notification.notificationId, notification]),
  );
  return incoming.map((notification) =>
    Option.from(knownById.get(notification.notificationId)).match({
      some: (knownNotification) => ({
        ...notification,
        actions: notification.actions.map((action) =>
          Option.from(
            knownNotification.actions.find(
              (knownAction) =>
                knownAction.actionId === action.actionId &&
                knownAction.state !== 'pending',
            ),
          ).match({
            some: (knownAction) =>
              action.state === 'pending' ? knownAction : action,
            none: () => action,
          }),
        ),
      }),
      none: () => notification,
    }),
  );
}
